/**
 * A marca na tela: logo quando existe, nome quando não.
 *
 * `fundo="cor"` (07/10/2026, A076): a tela está sobre a cor da marca ou um
 * fundo escuro, e o logo usado é o de fundo colorido (`logoSobreCorUrl`),
 * quando a marca tem um. Quem decide qual logo usar é este componente, não
 * cada tela.
 */
import { Box, Text } from '@mantine/core';

export interface BrandLogoProps {
  name: string;
  logoUrl?: string | null;
  /** O logo para fundo colorido (A076). Só é usado com `fundo="cor"`. */
  logoSobreCorUrl?: string | null;
  /** Sobre que fundo o logo está. Padrão: claro. */
  fundo?: 'claro' | 'cor';
  logoHasOwnBackground?: boolean;
  height?: number;
  /** Largura máxima do logo; o padrão segura logo largo em cabeçalho estreito. */
  maxWidth?: number;
}

export function BrandLogo({ name, logoUrl, logoSobreCorUrl, fundo = 'claro', logoHasOwnBackground, height = 40, maxWidth = 200 }: BrandLogoProps) {
  const usarVersaoParaCor = fundo === 'cor' && !!logoSobreCorUrl;
  const url = usarVersaoParaCor ? logoSobreCorUrl : logoUrl;
  if (!url) {
    return (
      // Sem logo, o nome cresce com a altura pedida (nunca abaixo do xl de antes).
      // Sobre fundo colorido, o nome vai em branco: na cor da marca, sumiria.
      <Text fw={700} fz={Math.max(20, Math.round(height * 0.4))} c={fundo === 'cor' ? '#FFFFFF' : 'brand'} style={{ lineHeight: 1 }}>
        {name}
      </Text>
    );
  }
  return (
    <Box
      component="img"
      src={url}
      alt={name}
      style={{
        height,
        maxWidth,
        objectFit: 'contain',
        borderRadius: logoHasOwnBackground && !usarVersaoParaCor ? 'var(--eva-radius-sm)' : 0,
      }}
    />
  );
}
